import ImageChecker from "utils/imageCkeck";
import { Button, Img } from 'components';
import { Button as ButtonTooltip, Tooltip, Whisper } from "rsuite";
import supprimerImg from 'assets/images/delete.png';
import modifierImg from 'assets/images/crayon.png';



const ParticipantsTableau = ({ participants, handleRemoveRow, handleModifyRow }) => {
    const formatNumberWithLeadingZero = (num) => {
        return num < 10 ? `0${num}` : num.toString();
    };

    return (
        <>
            <table className="border border-collapse border-solid table-auto border-black-900">
                <thead>
                    <tr className="items-start bg-[#81E7AF]">
                        <th className="border border-solid border-black-900 p-2 w-[2%]">N° d'ordre</th>
                        <th className="border border-solid border-black-900 p-2 w-[2%]">Nom et prénoms</th>
                        <th className="border border-solid border-black-900 p-2 w-[2%]">Qualité</th>
                        <th className="border border-solid border-black-900 p-2 w-[2%]">Lieu de résidence</th>
                        <th className="border border-solid border-black-900 p-2 w-[2%]">Signature</th>
                        <th className="border border-solid border-black-900 p-2 w-[2%]">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {participants.map((participant, index) => (
                        <tr key={participant.id}>
                            <td className="border border-solid border-black-900 p-2 w-[2%]">
                                {formatNumberWithLeadingZero(index + 1)}
                            </td>
                            <td className="border border-solid border-black-900 p-2 w-[2%]">
                                {participant.nom_prenom}
                            </td>
                            <td className="border border-solid border-black-900 p-2 w-[2%]">
                                {participant.qualite}
                            </td>
                            <td className="border border-solid border-black-900 p-2 w-[2%]">
                                {participant.lieu_residence}
                            </td>
                            <td className="border border-solid border-black-900 p-2 w-[2%]">
                                <div
                                    style={{
                                        width: '150px',
                                        height: '130px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        textAlign: 'justify',
                                    }}
                                >
                                    <Img
                                        style={{
                                            width: '100%',
                                        }}
                                        className="cursor-pointer h-full w-[15px] items-end justify-right m-2 w-full"
                                        alt="modifier"
                                        src={participant.signature}
                                    />
                                </div>
                            </td>
                            <td className="border border-solid border-black-900 p-2 w-[2%]">
                            <div className="flex flex-row gap-1 items-start justify-center w-full">            
                                <Whisper
                                    followCursor
                                    speaker={
                                        <Tooltip>modifier</Tooltip>
                                    }
                                >
                                    <ButtonTooltip
                                        size="xs"
                                        onClick={() =>
                                            handleModifyRow(index)
                                        }
                                    >
                                        <Img
                                            className="cursor-pointer h-full w-[15px] items-end justify-right m-2"
                                            alt="modifier"
                                            src={modifierImg}
                                        />
                                    </ButtonTooltip>
                                </Whisper>
                                <Whisper
                                    followCursor
                                    speaker={
                                        <Tooltip>Supprimer</Tooltip>
                                    }
                                >
                                    <ButtonTooltip
                                        size="xs"
                                        onClick={() =>
                                            handleRemoveRow(index)
                                        }
                                    >
                                        <Img
                                            className="cursor-pointer h-full w-[15px] items-end justify-right m-2"
                                            alt="supprimer"
                                            src={supprimerImg}
                                        />
                                    </ButtonTooltip>
                                </Whisper>
                            </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
}

export default ParticipantsTableau;